import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { getIsMobile } from '../utils/deviceUtils';
import { Step } from '../views/Step';
import { FlowConfigRecord } from './FlowConfig';
import { isFlow } from '../utils/isFlow';

const getPostAccountCreationSteps = flowConfig => {
  let postAccountCreationSteps = flowConfig.steps.postAccountCreation || [];

  if (flowConfig.shouldAddHubInterestStep()) {
    if (isFlow(Flow.Crm)) {
      postAccountCreationSteps = postAccountCreationSteps.concat([Step.UseCase]);
    }

    postAccountCreationSteps = postAccountCreationSteps.concat([Step.HubInterest]);
  }

  if (flowConfig.showMobileAppPrompt && getIsMobile()) {
    postAccountCreationSteps = postAccountCreationSteps.concat([Step.MobileAppPrompt]);
  }

  return postAccountCreationSteps;
};

export const getFlowConfig = () => {
  const flowKey = getFlowKey();
  const flowConfig = FlowConfigRecord[flowKey];

  if (!flowConfig) {
    throw new Error(`Invalid flow with key ${flowKey}.`);
  }

  return flowConfig;
};
export const getFlowSteps = () => {
  const flowConfig = getFlowConfig();
  const {
    preVerification,
    postExistingAccountSelection,
    postVerification
  } = flowConfig.steps;
  return {
    preVerification,
    postVerification,
    postExistingAccountSelection,
    postAccountCreation: getPostAccountCreationSteps(flowConfig)
  };
};